import { Link_default } from "./chunk-EFRJ3CR6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/ChipGroup/ChipGroup.Item.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "span";
var ChipGroupItem = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      onDismiss,
      dismissLabel,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "onDismiss", "dismissLabel", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    className: clsx("pd-chip-group__item", className)
  }, rest), children, /* @__PURE__ */React.createElement(Link_default, {
    as: "button",
    type: "button",
    variant: "secondary",
    onClick: onDismiss,
    iconBefore: "times",
    screenReaderLabel: dismissLabel
  }));
});
var StoryChipGroupItem = args => /* @__PURE__ */React.createElement(ChipGroupItem, __spreadValues({}, args));
var ChipGroup_Item_default = ChipGroupItem;
export { StoryChipGroupItem, ChipGroup_Item_default };